<template>
  <div class="default-layout">
    <Header>
      <slot name="header"></slot>
    </Header>
    <main class="main">
      <!--<div class="background-colored"></div>-->
      <div class="main-contents">
        <div class="container">
          <slot />
        </div>
      </div>
      <button
        :class="$style.supportDeskBtn"
        @click="redirectToSupport"
        aria-label="Support Desk"
      >
        <i class="mdi mdi-face-agent" :class="$style.icon"></i>
      </button>
      <Footer>
        <slot name="footer"></slot>
      </Footer>
    </main>
  </div>
</template>

<script lang="ts">
import Header from '../components/base/Header.vue';
import Footer from '../components/base/Footer.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { Header, Footer },
})
export default class DefaultLayout extends Vue {
  public redirectToSupport() {
    window.open(
      `${Vue.prototype.JBI_GLOBAL_URL}/servicedesk/customer/portal/3`,
      '_blank',
    );
  }
}
</script>
<style lang="scss" module>
.supportDeskBtn {
  position: fixed;
  bottom: 4vh;
  right: 2.5vw;
  width: 64px; /* Target size */
  height: 64px; /* Target size */
  border-radius: 50%; /* Make it circular */
  background-color: #00205b; /* Target background color */
  border: none; /* Remove default button border */
  cursor: pointer;
  display: flex; /* Enable flexbox for centering */
  align-items: center; /* Center icon vertically */
  justify-content: center; /* Center icon horizontally */
  padding: 0; /* Remove padding, no text content */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* Optional: Add subtle shadow like the design */
  transition: background-color 0.2s ease; /* Optional: Smooth hover transition */

  /* Tooltip Pseudo-element Styling */
  &::after {
    content: 'Support Desk'; /* The text to display */
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-70%); /* Adjust horizontal centering */
    margin-bottom: 8px;
    background-color: #2c3e50;
    color: white; /* Text color */
    padding: 5px 10px; /* Padding inside the tooltip */
    border-radius: 4px;
    font-size: 14px;
    font-weight: normal;
    white-space: nowrap; /* Prevent text wrapping */
    opacity: 0; /* Hidden by default */
    visibility: hidden; /* Hidden by default */
    pointer-events: none; /* Prevent tooltip from interfering with mouse events */
    transition: opacity 0.2s ease, visibility 0.2s ease;
    z-index: 10; /* Ensure tooltip appears above other elements if needed */
  }

  /* Show Tooltip on Hover */
  &:hover {
    background-color: #003380; /* Slightly lighter blue on hover */

    &::after {
      opacity: 1; /* Make tooltip visible */
      visibility: visible; /* Make tooltip visible */
    }
  }
}

.icon {
  color: white; /* Target icon color */
  font-size: 36px; /* Adjust icon size as needed to fit well in 64px button */
  line-height: 1; /* Ensure icon aligns properly */
}
</style>
